import { useApiSend } from '../../shared/api/utils/reactQueryProvider';
import { unclaimRide } from '../api/services/Rides';

interface iRideUnclaimSubmit {
  rideSlug: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useRideUnclaimSubmit = ({ rideSlug, onSuccess, onError }: iRideUnclaimSubmit) => {
  return useApiSend(
    (payload: { removeDriver: { driverRemovalReason: string } }) => unclaimRide(rideSlug, payload),
    onSuccess,
    onError,
    ['rideDetails'],
    undefined
  );
};
